import React from 'react'

interface ConversationHeaderProps {
    title: React.ReactNode
    trailingWidget?: React.ReactNode
}

export const ThreadHeader: React.FC<ConversationHeaderProps> = ({
    title,
    trailingWidget,
}) => {
    return (
        <>
            <div className="flex h-[68px] shrink-0">
                {title}
                <div style={{ flex: 1 }} />
                <div
                    style={{
                        marginLeft: 'auto',
                        paddingTop: '23px',
                        paddingRight: '24px',
                    }}
                >
                    {trailingWidget}
                </div>
            </div>
            <div className="h-px w-full shrink-0 bg-[#e4e4e4]" />
        </>
    )
}
